import { render } from "./MobileNavigation.vue?vue&type=template&id=efaaf4e4&scoped=true"
import script from "./MobileNavigation.vue?vue&type=script&lang=js"
export * from "./MobileNavigation.vue?vue&type=script&lang=js"

import "./MobileNavigation.vue?vue&type=style&index=0&id=efaaf4e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efaaf4e4"]])

export default __exports__